export default __webpack_public_path__ + "static/image_1-cb8252df5af4da364fa9f09d68ba6c70.webp";